module.exports = __webpack_public_path__ + "static/media/certificate1.bbb22c82.webp";